<template>
    <div class="wl-new-center-detail">
        <div class="new-center-content">
            <div class="new-center-top fl">
                <div class="new-top-nav" :style="{ background: 'url(' + imgcen + ')' }">
                    <h1 class="new-top-title fl">N</h1>
                    <div class="fl" style="padding-left:4px;">
                        <p class="new-top-navtitle">新闻中心</p>
                        <p class="new-top-ews">EWS</p>
                    </div>
                </div>
                <div class="new-center-tab">
                    <div class="new-center-dynamic" @click="getNewCenter(1)" :class="{ classback: isShow == 1 }">
                        新闻动态
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                    <div class="new-center-dynamic" @click="getNewCenter(2)" :class="{ classback: isShow == 2 }">
                        通知公告
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                </div>
            </div>
            <div class="new-breadcrumb-trail">
                <h2 v-show="isShow == 1">新闻动态</h2>
                <h2 v-show="isShow == 2">通知公告</h2>
                <div class="crumbs-text">
                    <i class="wl-icon-zhuye1"></i>
                    <span>当前位置：</span>
                    <span @click="goHome">网站首页</span>
                    <span>></span>
                    <span @click="goNews">
                        <span v-show="isShow == 1">新闻中心</span>
                        <span v-show="isShow == 2">通知公告</span>
                    </span>
                    <span>></span>
                    <span>{{ newsInfo.Title }}</span>
                </div>
            </div>
            <div class="new-center-detail">
                <div class="new-center-title">
                    <h3 class="h3-news-title">{{ newsInfo.Title }}</h3>
                    <p class="p-news-date">发布时间：{{ newsInfo.PulishTime }}</p>
                    <div class="class-news-content fr-view">
                        <p v-html="newsInfo.Content"></p>
                    </div>
                </div>
            </div>
            <div style="margin-left:250px;">
                <!-- <studySource></studySource> -->
            </div>
        </div>
        <div class="ph-new-center-content">
            <div class="crumbs-text">
                <div style="padding:0 20px;">
                    <i class="wl-icon-zhuye1"></i>
                    <span @click="goHome" style="cursor: pointer;">首页</span>
                    <span>></span>
                    <span v-show="isShow == 1" @click="getNewCenter(1)">新闻动态</span>
                    <span v-show="isShow == 2">通知公告</span>
                </div>
            </div>
            <!-- <div class="new-breadcrumb-trail">
                <h2 v-show="isShow == 1">新闻动态</h2>
                <h2 v-show="isShow == 2">通知公告</h2>
            </div> -->
            <div class="new-center-detail">
                <div class="new-center-title">
                    <h3 class="h3-news-title">{{ newsInfo.Title }}</h3>
                    <p class="p-news-date">发布时间：{{ newsInfo.PulishTime }}</p>
                    <div class="class-news-content fr-view">
                        <p v-html="newsInfo.Content"></p>
                    </div>
                </div>
            </div>
            <div style="margin-left:250px;">
                <!-- <studySource></studySource> -->
            </div>
        </div>
    </div>
</template>

<script>
import studySource from "page/component/school/studySource.vue";
export default {
    name: "Detail",
    components: {
        studySource,
    },
    props: {
        newsId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            newsInfo: {},
            isShow: 1,
            imgcen: require("../../assets/images/bg-news.png"),
        };
    },
    created() {
        this.getNewsInfo();
        if (this.$route.params.isTab == undefined) {
            this.isShow = 1;
        } else {
            this.isShow = this.$route.params.isTab;
        }
    },
    methods: {
        getNewCenter(num) {
            this.$router.push({
                name: "xNewsCenter",
                params: {
                    isTab: num,
                },
            });
        },
        goHome() {
            this.$router.push({
                name: "xHome",
            });
        },
        goNews() {
            this.$router.push({
                name: "xNewsCenter",
            });
        },
        getNewsInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationIndex/getNewsInfo", {
                    Id: that.newsId,
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.newsInfo = rst.newsInfo;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
    },
};
</script>
